export const IMPERSONATE_ENDPOINT = 'authres/csr/azure/impersonate'
export const IMPERSONATE_PAGE = 'authres/csr/switchUser.html-v8'
